module.exports = __webpack_public_path__ + "media/images/scribe-textbook-small-810d6bdf.png";